export default __webpack_public_path__ + "static/media/DashboardImg.66df5ca1.png";